import React from 'react';
import { Paper } from '@mui/material';

/**
 * Base surface for all cards / panels. Replaces every hand-rolled glassmorphism Paper.
 *
 * Variants:
 *   default  — standard raised card
 *   subtle   — flatter, for secondary panels / inputs backdrops
 *   accent   — primary-tinted, for highlighted heroes
 *
 * Forwards refs so motion(Surface) works correctly with Framer Motion variants.
 */
const Surface = React.forwardRef(function Surface(
    { variant = 'default', padding = 3, interactive = false, sx = {}, children, ...rest },
    ref
) {
    const variantStyles = {
        default: {
            backgroundColor: theme => theme.palette.custom.surface.raised,
            border: theme => `1px solid ${theme.palette.custom.border.subtle}`,
        },
        subtle: {
            backgroundColor: theme => theme.palette.custom.surface.subtle,
            border: theme => `1px solid ${theme.palette.custom.border.subtle}`,
        },
        accent: {
            backgroundColor: 'rgba(99,102,241,0.05)',
            border: '1px solid rgba(99,102,241,0.2)',
        },
    };

    const interactiveStyles = interactive
        ? {
              cursor: 'pointer',
              transition: theme =>
                  `border-color ${theme.customTransitions.fast}, background-color ${theme.customTransitions.fast}`,
              '&:hover': {
                  borderColor: theme => theme.palette.custom.border.strong,
                  backgroundColor: theme => theme.palette.custom.surface.elevated,
              },
          }
        : {};

    return (
        <Paper
            ref={ref}
            elevation={0}
            sx={{
                p: padding,
                ...variantStyles[variant],
                ...interactiveStyles,
                ...sx,
            }}
            {...rest}
        >
            {children}
        </Paper>
    );
});

export default Surface;
